import type { QueryClient } from '@tanstack/react-query';

// TODO: Move the SignalR contracts to the api/data feature in the PR that moves the tree-view feature.
import type { DataNodeUpdatedEvent } from 'api/data/events/signalREvents';

import { getGraphRootNodeQueryKeyPrefix } from '../hooks/useGraphRootNode';
import { PROJECT_GRAPH_CONNECTED_QUERY_KEY } from '../utils/connectedNodesQueryKey';

/**
 * DataNodeUpdated -> invalidate this read-model's own cached copies of the node.
 *
 * Invalidates rather than patching from the event payload: the payload isn't permission-filtered the
 * way the cached DTO is (see `features/node-details/README.md` backlog #6, an unresolved bug in the
 * node-details panel's patch-from-event path), so forcing a fresh GET avoids leaking or mis-setting a
 * property the viewer's role can't see. The root-node cache is targeted by id; the connected/pill cache
 * is invalidated coarsely by project, matching the existing "coarse match costs nothing" precedent in
 * `connectedNodesQueryKey.ts` and `useUpdateProjectNodeCell.ts`.
 *
 * Both matchers are built from the key factories the queries themselves use, so inserting or renaming
 * a key segment can't silently stop invalidation the way a duplicated literal would.
 */
export function invalidateProjectGraphNodeFromEvent(queryClient: QueryClient, event: DataNodeUpdatedEvent): void {
  const { ProjectId } = event;
  const { Id: nodeId } = event.Payload;
  if (!ProjectId || !nodeId) return;

  queryClient.invalidateQueries({ queryKey: getGraphRootNodeQueryKeyPrefix(ProjectId, nodeId) });
  queryClient.invalidateQueries({ queryKey: [PROJECT_GRAPH_CONNECTED_QUERY_KEY, ProjectId] });
}
